module.exports = __webpack_public_path__ + "static/img/maisnan.b6fef77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/maisnan.png
// module id = 27
// module chunks = 0